export default "__VITE_ASSET__3ce0cceb__"